import { Text, styled } from '@kandji-inc/nectar-ui';

export const LabelText = styled(Text, {
  color: '$neutral70',
  fontWeight: '$medium',
});
